import { ClientUserData } from "./components/ClientUserForm";
import { PostClient } from "./types";

export function clientUserDataToClient(
  clientData?: ClientUserData
): PostClient | undefined {
  if (!clientData) return undefined;
  const client: PostClient = {
    phone: clientData.phone ?? undefined,
    email: clientData.email ?? undefined,
    usinasIds: clientData.usinasIds ?? undefined,
  };
  return client;
}
export function clientToClientUserData(
  client: PostClient | null
): ClientUserData | undefined {
  if (!client) return undefined;
  const clientUserData: ClientUserData = {
    phone: client.phone,
    email: client.email ?? "",
    usinasIds: client.usinasIds,
  };
  return clientUserData;
}
